/** Exact decimal helpers: no binary floating-point rounding of exchange rates. */
export function floorRateFromMinor(numerator: number | bigint, numeratorScale: number, denominator: number | bigint, denominatorScale: number): bigint | null {
  if ((typeof numerator === "number" && !Number.isSafeInteger(numerator)) ||
      (typeof denominator === "number" && !Number.isSafeInteger(denominator))) return null;
  const n = BigInt(numerator), d = BigInt(denominator);
  if (n < 0n || d <= 0n) return null;
  return n * 100n * 10n ** BigInt(denominatorScale) / (d * 10n ** BigInt(numeratorScale));
}

export function formatRateHundredths(value: bigint | number | null): string {
  if (value == null) return "—";
  const units = BigInt(value);
  return `${(units / 100n).toLocaleString("ru-RU")},${String(units % 100n).padStart(2, "0")}`;
}

/** Legacy read-only rate values still use the same downward two-place display. */
export function formatRate(value: number | string | null | undefined): string {
  if (value == null) return "—";
  return formatRateHundredths(decimalFloorUnits(value, 2));
}

export function decimalFloorUnits(value: number | string, precision: number): bigint | null {
  const match = String(value).match(/^(\d+)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
  if (!match) return null;
  const fraction = match[2] || "", exponent = Number(match[3] || 0);
  const shift = precision + exponent - fraction.length;
  const units = BigInt(match[1] + fraction);
  return shift >= 0 ? units * 10n ** BigInt(shift) : units / 10n ** BigInt(-shift);
}

/** Valid partial edits are accepted, oversized paste/edit is rejected as a whole. */
export function boundedMoneyInput(value: string, precision: number, maxMinor?: number): boolean {
  if (!new RegExp(`^\\d*(?:[.,]\\d{0,${precision}})?$`).test(value) ||
      (precision === 0 && /[.,]/.test(value))) return false;
  if (!value || /^[.,]$/.test(value)) return true;
  const [whole, fraction = ""] = value.replace(",", ".").split(".");
  const units = BigInt(whole || "0") * 10n ** BigInt(precision) + BigInt(fraction.padEnd(precision, "0") || "0");
  return units <= BigInt(Number.MAX_SAFE_INTEGER) &&
    (maxMinor == null || units <= BigInt(Math.max(0, Math.floor(maxMinor))));
}
